import * as React from 'react';
import styled from '@emotion/styled';
import { Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';
import { Tooltip } from '@lightspeed/flame/Tooltip';
import { Group } from '@lightspeed/flame/Group';
import { IconHelp } from '@lightspeed/flame/Icon/Help';
import { useGetAppDownloadUrl } from 'pages/views/devices/hooks/use-get-app-download-url';
import { getDetectedPlatform, APP_NAME } from 'pages/views/devices/utils/helper';
import { DownloadAppElement } from './DownloadAppElement';
import { PLATFORMS } from '../types';

const StyledTooltip = styled(Tooltip)`
  width: 240px;
`;

const ErrorMessages = {
  PLATFORM: 'Only Mac and Windows operating system are supported',
  NOTFOUND: 'No download link was found. We have been notified please try again later.',
  ERROR: 'There was an error with the download link. Try reloading the page.',
};

interface DownloadHubProps {
  isButton?: boolean;
  content?: string;
  [key: string]: any;
}

const DownloadHub: React.FunctionComponent<DownloadHubProps> = ({ isButton, content, ...rest }) => {
  const { isAppDownloadAvailable, appDownloadLinks, errorMessage } = useGetAppDownloadUrl();
  const { platform } = getDetectedPlatform();

  React.useEffect(() => {
    if (!window.newrelic || !errorMessage || errorMessage !== ErrorMessages.NOTFOUND) return;

    window.newrelic.noticeError(new Error(`${APP_NAME} app download link - ${errorMessage}`));
  }, [errorMessage]);

  return (
    <>
      {!isAppDownloadAvailable ? (
        <Flex flexDirection="column" justifyContent="center" alignItems="flex-start" ml={3}>
          <Group>
            <Text color="maple">Download unavailable</Text>
            {errorMessage ? (
              <StyledTooltip content={errorMessage}>
                <IconHelp color="maple" />
              </StyledTooltip>
            ) : null}
          </Group>
        </Flex>
      ) : (
        <DownloadAppElement
          {...rest}
          url={appDownloadLinks?.[platform as PLATFORMS]}
          isButton={isButton}
          content={content || `Download ${APP_NAME}`}
        />
      )}
    </>
  );
};

export { DownloadHub };
